module.exports = __webpack_public_path__ + "img/card_3_ref_1.1699a7c7.jpg";